import InputFieldContainer, { InputFieldContainerProps } from './InputFieldContainer';
import { useWidgetContext } from '../context/WidgetContext';

export default function PasswordField(props: InputFieldContainerProps) {

  const { athenaOneWebSso, athenaOneWebNonSsoTimedOut } = useWidgetContext();

  // Hide the password field for iframed widgets
  if (athenaOneWebSso || athenaOneWebNonSsoTimedOut) {
    return <></>;
  }
  return (
    <InputFieldContainer {...props} id="athena-password" />
  );
}
